<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2022-12-03 13:07:27
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-05-06 17:15:38
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/supplierManagement/components/baseInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--  -->
<template>
  <div class="contents">
    <div class="head-title">合作信息</div>
    <div class="info-wrap">
      <div>
        <div class="floor left">
          <ul>
            <li>
              <span class="item">综合得分:</span
              ><span class="item-1">{{
                supplierScoreInfo.compositeScore
              }}</span>
            </li>
            <li>
              <span class="item">供应商分级:</span>
              <span class="item-1">{{
                formatterSupplierLevel(supplierScoreInfo.supplierLevel)
              }}</span>
            </li>
            <li>
              <span class="item">常采目录:</span
              ><span class="item-1">{{
                supplierScoreInfo.collectCatalog
              }}</span>
            </li>
          </ul>
        </div>
        <div class="floor middle">
          <ul>
            <li>
              <span class="item">合作状态:</span
              ><span class="item-1">{{
                supplierScoreInfo.cooperationStatus === 1 ? '启用' : '停用'
              }}</span>
            </li>
            <li>
              <span class="item">交易量(元):</span
              ><span class="item-1">{{ supplierScoreInfo.tradeAmount }}</span>
            </li>
            <li>
              <span class="item">所在地区:</span
              ><span class="item-1">{{ supplierScoreInfo.area }}</span>
            </li>
          </ul>
        </div>
        <div class="floor right">
          <ul>
            <li>
              <span class="item">添加时间:</span
              ><span class="item-1">{{ supplierScoreInfo.createTime }}</span>
            </li>
            <li>
              <span class="item">产品目录:</span>
              <div class="txt-link-color" @click="showCategoryList">查看</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 供应商的产品目录 -->
    <product-category-dialog
      :classifyVisible.sync="supplierCategoryVisible"
      @resetPopupData="supplierCategoryVisible = false"
      :categoryTreeData="supplierCategoryTreeData"
      @submitPopupData="supplierCategoryVisible = false"
    >
    </product-category-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import productCategoryDialog from './productCategoryDialog.vue';
import api from '../../../api/user';
export default {
  data() {
    return {
      supplierCategoryVisible: false,
      supplierCategoryTreeData: [],
    };
  },

  components: { productCategoryDialog },

  computed: {
    ...mapState(['supplierScoreInfo']),
  },

  created() {},
  methods: {
    async getSupplierCategoryList(id) {
      let res = await api.querySupplierProductCatalogInfo(id);
      if (parseInt(res.code) === 200) {
        this.supplierCategoryTreeData = res.data;
      }
    },
    showCategoryList() {
      let id = this.$route.query.supplierId;
      this.getSupplierCategoryList(id);
      this.supplierCategoryVisible = true;
    },
    formatterSupplierLevel(code) {
      let str = '';
      switch (code) {
        case 1:
          str = '战略';
          break;
        case 2:
          str = '重要';
          break;
        case 3:
          str = '一般';
          break;

        default:
          break;
      }
      return str;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.contents {
  // width: 1010px;
  // margin:0 auto;
  border: 1px solid #d9d9d9;
  margin-bottom: 20px;
  .head-title {
    color: #333;
    font-size: 14px;
    background: #d9d9d9;
    padding: 15px 20px;
    margin-bottom: 20px;
  }
  .info-wrap {
    padding-left: 20px;
    .company-name {
      font-size: 16px;
      color: #333;
      margin-top: 20px;
      font-weight: 500;
      margin-bottom: 20px;
    }
    & > div {
      display: flex;
      justify-content: space-between;
    }
    .floor {
      width: 30%;
      ul {
        li {
          line-height: 1;
          margin-bottom: 20px;
        }
      }
      .item {
        display: inline-block;
        color: #333;
        font-size: 14px;
        //   width: 40%;
        text-align: right;
        margin-right: 10px;
      }
      .item-1 {
        color: #333;
        font-size: 14px;
      }
    }
    .left {
      ul {
        li {
          line-height: 1;
          margin-bottom: 20px;
        }
      }
      .item {
        display: inline-block;
        color: #333;
        font-size: 14px;
        //   width: 32%;
        text-align: left;
        margin-right: 10px;
      }
      .item-1 {
        color: #333;
        font-size: 14px;
      }
    }
    //    .middle{
    //     width: 20%;
    //     p{
    //         font-size: 14px;
    //         color: #333;
    //     }
    //    }
    .right {
      p {
        font-size: 14px;
        color: #333;
      }
    }
  }
}
</style>
